<div class="main-content table-page table-page--compact grupos-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Administración de Grupos</h1>
        <p>Consulte grupos, subgrupos y oportunidades relacionadas desde una sola vista operativa.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="actualizarDesdeGitlab()" [disabled]="loading">
          <i class="material-icons">sync</i>
          <span>Actualizar GitLab</span>
        </button>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="openAddGroup()">
          <i class="material-icons">add</i>
          <span>Agregar Grupo</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--wide table-page__field">
            <mat-label>Nombre del grupo</mat-label>
            <input aria-label="Nombre del grupo" type="text" matInput autocomplete="off" [(ngModel)]="nomGrupo" (keyup)="consultarGrupos(1)" />
            <button *ngIf="nomGrupo" type="button" matSuffix mat-icon-button (click)="clearNombrePro()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
            <mat-label>Fecha</mat-label>
            <input aria-label="Fecha" matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" [(ngModel)]="fecha"
              (dateChange)="consultarGrupos(1)" />
            <button *ngIf="fecha" type="button" matSuffix mat-icon-button (click)="clearDate($event)">
              <mat-icon>close</mat-icon>
            </button>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listaGrupos.length > 0; else gruposEmptyState">
          <thead>
            <tr>
              <th>Grupo</th>
              <th>Fecha de alta</th>
              <th>Fecha de vigencia</th>
              <th class="table-page__actions-head">Detalle</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let grupo of listaGrupos; let i = index">
              <tr class="is-clickable" [class.is-selected]="expandedGroupIndex === i" (click)="toggleGroup(i)" (keydown.enter)="$event.target === $event.currentTarget ? toggleGroup(i) : null">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ grupo.nombre || "Sin nombre" }}</strong>
                    <span class="table-page__subtext">
                      {{ hasChildren(grupo) ? (grupo.listaOportunidad.length + " subgrupos") : "Sin subgrupos" }}
                    </span>
                  </div>
                </td>
                <td>
                  <span class="table-page__text">{{ getFormattedDate(grupo.fecha_alta) }}</span>
                </td>
                <td>
                  <span class="table-page__text">{{ getFormattedDate(grupo.fecha_vigencia) }}</span>
                </td>
                <td class="table-page__actions">
                  <button type="button" class="table-page__action-btn" matTooltip="Expandir detalle" (click)="$event.stopPropagation(); toggleGroup(i)">
                    <i class="material-icons">{{ expandedGroupIndex === i ? "expand_less" : "expand_more" }}</i>
                  </button>
                </td>
              </tr>

              <tr *ngIf="expandedGroupIndex === i" class="grupos-page__detail-row">
                <td colspan="4">
                  <div class="grupos-page__detail-wrap">
                    <div class="grupos-page__detail-head">
                      <div class="table-page__cell-stack">
                        <strong class="table-page__name">Subgrupos y oportunidades</strong>
                        <span class="table-page__subtext">Detalle asociado a {{ grupo.nombre }}</span>
                      </div>
                    </div>

                    <div class="grupos-page__nested-empty" *ngIf="!hasChildren(grupo)">
                      No existen subgrupos a mostrar.
                    </div>

                    <table *ngIf="hasChildren(grupo)" class="grupos-page__nested-table">
                      <thead>
                        <tr>
                          <th>Subgrupo</th>
                          <th>Descripción</th>
                          <th>Fecha de creación</th>
                          <th class="table-page__actions-head">Detalle</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let oportunidad of grupo.listaOportunidad; let j = index">
                          <tr class="is-clickable" [class.is-selected]="expandedOpportunityIndex === j"
                            (click)="toggleOpportunity(j)" (keydown.enter)="$event.target === $event.currentTarget ? toggleOpportunity(j) : null">
                            <td>
                              <div class="table-page__cell-stack">
                                <strong class="table-page__name">{{ oportunidad.nombreCliente || "Sin subgrupo" }}</strong>
                                <span class="table-page__subtext">{{ oportunidad.nombre || "Sin oportunidad" }}</span>
                              </div>
                            </td>
                            <td>{{ oportunidad.descripcion || "Sin descripción" }}</td>
                            <td>{{ getFormattedDate(oportunidad.fechaCreacion) }}</td>
                            <td class="table-page__actions">
                              <button type="button" class="table-page__action-btn" matTooltip="Expandir detalle"
                                (click)="$event.stopPropagation(); toggleOpportunity(j)">
                                <i class="material-icons">{{ expandedOpportunityIndex === j ? "expand_less" : "expand_more" }}</i>
                              </button>
                            </td>
                          </tr>

                          <tr *ngIf="expandedOpportunityIndex === j" class="grupos-page__detail-row">
                            <td colspan="4">
                              <div class="grupos-page__opportunity-card">
                                <div class="table-page__cell-stack">
                                  <strong class="table-page__name">{{ oportunidad.nombre || "Sin nombre de oportunidad" }}</strong>
                                  <span class="table-page__subtext">Última actualización: {{ getFormattedDate(oportunidad.fechaActualizacion) }}</span>
                                </div>

                                <div class="grupos-page__opportunity-comment">
                                  {{ oportunidad.comentarios?.[0]?.contenido || "No hay comentarios a mostrar." }}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <ng-template #gruposEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else gruposLoadingState">
            <i class="material-icons">folder_open</i>
            <strong>No se encontraron grupos</strong>
            <span>Ajuste los filtros o registre un grupo nuevo para continuar.</span>
          </div>
        </ng-template>

        <ng-template #gruposLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando grupos...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} grupos</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()"
            [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else gruposPagerEllipsis" type="button"
              class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #gruposPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()"
            [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()"
            [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
